import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitobhimashankarcab() {



const cardData = {
  keyword: "Mumbai to Bhimashankar Cab",

headingDescription:
  "Omshree Cab offers safe and comfortable Mumbai to Bhimashankar cab services for travelers looking to visit one of Maharashtra’s most revered pilgrimage and natural destinations. Whether you are planning a spiritual trip, a nature retreat, or a weekend getaway, our cab service ensures a smooth and convenient journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet features air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs experienced in long-distance and hilly routes, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Bhimashankar cab services.",

topPlaces: [
  {
    title: "Bhimashankar Temple",
    description:
      "Bhimashankar Temple is the main attraction in Bhimashankar, dedicated to Lord Shiva and one of the twelve Jyotirlingas in India. Nestled in the Sahyadri hills, the temple attracts devotees and tourists alike for its spiritual significance and serene surroundings. Visitors can participate in daily rituals, observe traditional ceremonies, and enjoy the peaceful forested area. Traveling by cab ensures a comfortable journey through the winding mountain roads, allowing visitors to arrive relaxed and explore the temple and its surroundings at their own pace."
  },
  {
    title: "Bhimashankar Wildlife Sanctuary",
    description:
      "Bhimashankar Wildlife Sanctuary surrounds the temple and is known for its rich biodiversity, dense forests, and wildlife including the Indian giant squirrel and various bird species. Nature enthusiasts and trekkers can enjoy scenic trails, wildlife spotting, and photography. Using a cab allows travelers to reach the sanctuary conveniently, spend ample time exploring its natural beauty, and return safely without worrying about local transport in the hilly terrain."
  },
  {
    title: "Gangamai Waterfall",
    description:
      "Gangamai Waterfall is a picturesque waterfall located near Bhimashankar Temple, ideal for nature lovers and photography enthusiasts. The waterfall cascades down rocky cliffs into a serene pool, surrounded by lush greenery. A cab ride ensures comfortable access to the site, allowing visitors to enjoy the waterfall, take scenic photographs, and relax in the peaceful environment without the hassle of navigating narrow mountain roads on their own."
  },
  {
    title: "Kalsubai Peak (Nearby)",
    description:
      "Kalsubai Peak, the highest point in Maharashtra, is located near Bhimashankar and is popular among trekkers and adventure enthusiasts. The peak offers panoramic views of the Sahyadri range and surrounding valleys. Traveling by cab allows visitors to reach the base comfortably and plan their trekking schedule efficiently, making it possible to combine spiritual and adventure experiences in a single trip."
  },
  {
    title: "Hanuman Lake",
    description:
      "Hanuman Lake is a tranquil spot near Bhimashankar Temple, ideal for relaxation and nature walks. Surrounded by forests and hills, the lake provides a peaceful setting for photography and quiet reflection. A cab service ensures easy and safe access to the lake, enabling visitors to enjoy the serene environment as part of their Bhimashankar trip without worrying about local transport challenges."
  },
  {
    title: "Penchala Fort (Nearby)",
    description:
      "Penchala Fort is a historic hill fort near Bhimashankar that offers panoramic views of the surrounding Sahyadri hills. The fort is ideal for history enthusiasts and trekkers who enjoy exploring ancient structures amidst natural beauty. Traveling by cab ensures convenient access to the base of the fort, allowing travelers to plan a comfortable day trip from Bhimashankar while including nearby attractions."
  },
  {
    title: "Bhima River Viewpoints",
    description:
      "The Bhima River flows through the region surrounding Bhimashankar, providing several scenic viewpoints along its banks. Visitors can enjoy photography, bird watching, and peaceful riverside walks. A cab service allows travelers to reach multiple viewpoints efficiently, making it easy to enjoy the natural beauty of the Bhima River without worrying about navigation or transport."
  },
  {
    title: "Shivneri Hills (Nearby)",
    description:
      "Shivneri Hills, near Bhimashankar, are known for their scenic beauty, trekking trails, and historical significance. The hills offer panoramic views, opportunities for short treks, and a chance to experience the Sahyadri landscape. Traveling by cab ensures comfortable access, flexibility in timing, and the ability to combine multiple hill and nature visits in one itinerary."
  },
  {
    title: "Bhima Valley Trekking Routes",
    description:
      "The valleys around Bhimashankar offer trekking routes suitable for beginners and experienced trekkers alike, surrounded by dense forests and streams. Trekking enthusiasts can explore flora, fauna, and scenic landscapes along these trails. Using a cab allows travelers to reach trailheads conveniently and plan their trekking routes efficiently, ensuring a safe and enjoyable adventure experience."
  },
  {
    title: "Local Bhimashankar Market",
    description:
      "The local Bhimashankar market is a small hub where visitors can buy souvenirs, religious items, local snacks, and handicrafts. It offers a glimpse into local culture and traditions. Traveling by cab ensures that visitors can explore the market comfortably, combine it with temple and nature visits, and return to their vehicle safely without relying on public transport."
  }
],

services: [
{
name: "Mumbai to Bhimashankar Cab",
description: "Mumbai to Bhimashankar cab service offers comfortable travel for devotees visiting the sacred Bhimashankar Jyotirlinga temple. Our AC sedans, SUVs, and premium vehicles ensure a smooth highway and ghat road journey. Professional drivers are experienced with hill routes and temple travel. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for pilgrimage trips, family travel, and weekend temple visits."
},
{
name: "Mumbai to Bhimashankar Taxi",
description: "Mumbai to Bhimashankar taxi service provides reliable transportation for devotees traveling to the famous Jyotirlinga shrine. Comfortable AC vehicles ensure relaxed long-distance travel. Experienced drivers ensure safe driving through ghat sections near the temple. Flexible pickup options are available across Mumbai."
},
{
name: "Mumbai to Bhimashankar Cab Service",
description: "Mumbai to Bhimashankar cab service is designed for pilgrims and tourists seeking comfortable temple travel. Well-maintained vehicles and trained drivers ensure smooth highway journeys. Pickup is available from all areas in Mumbai including airport terminals. Spacious interiors and AC comfort improve long-distance travel."
},
{
name: "Mumbai to Bhimashankar Taxi Service",
description: "Mumbai to Bhimashankar taxi service offers dependable transportation for pilgrimage travel to the sacred temple. Comfortable vehicles ensure relaxed journeys through scenic hill routes. Professional drivers provide safe driving and timely arrival for darshan."
},
{
name: "Cab from Mumbai to Bhimashankar",
description: "Cab from Mumbai to Bhimashankar provides convenient private transportation for devotees visiting the temple. Comfortable vehicles ensure smooth travel on highways and ghat roads. Experienced drivers ensure safe and timely arrival. Ideal for family temple visits and pilgrimage tours."
},
{
name: "Taxi from Mumbai to Bhimashankar",
description: "Taxi from Mumbai to Bhimashankar offers reliable road travel with comfortable AC vehicles and experienced drivers. The service is ideal for pilgrims visiting the Bhimashankar Jyotirlinga temple. Flexible pickup locations across Mumbai make travel convenient."
},
{
name: "Mumbai to Bhimashankar Cab Booking",
description: "Mumbai to Bhimashankar cab booking allows devotees to reserve vehicles easily for temple travel. Instant booking confirmation and flexible pickup options simplify trip planning. Sedan, SUV, and premium vehicles are available for comfortable journeys."
},
{
name: "Mumbai to Bhimashankar Taxi Booking Online",
description: "Online taxi booking from Mumbai to Bhimashankar allows passengers to reserve vehicles instantly. Quick confirmation and easy scheduling make pilgrimage travel planning simple. AC vehicles and professional drivers ensure comfortable journeys."
},
{
name: "Mumbai to Bhimashankar Cab Price",
description: "Mumbai to Bhimashankar cab price offers affordable and transparent fare options for temple travel. Travelers can choose sedan, SUV, or luxury vehicles depending on comfort and budget. Clear pricing ensures no hidden charges."
},
{
name: "Mumbai to Bhimashankar Taxi Fare",
description: "Mumbai to Bhimashankar taxi fare is calculated with transparent per-km pricing and simple billing. Travelers receive affordable travel options with clear fare structure. Comfortable vehicles ensure relaxed temple journeys."
},
{
name: "Mumbai to Bhimashankar Temple Cab",
description: "Mumbai to Bhimashankar temple cab service is ideal for devotees planning direct travel to the sacred shrine. Comfortable vehicles ensure smooth journeys through scenic forest and hill roads. Professional drivers ensure safe and timely arrival for darshan."
},
{
name: "Mumbai to Bhimashankar Jyotirlinga Cab",
description: "Mumbai to Bhimashankar Jyotirlinga cab service provides dedicated pilgrimage travel to one of the twelve Jyotirlingas of Lord Shiva. Comfortable AC vehicles and experienced drivers ensure smooth travel. Ideal for family pilgrimage tours."
},
{
name: "Mumbai to Bhimashankar One Way Cab",
description: "One way cab from Mumbai to Bhimashankar is ideal for travelers who only require drop service without paying return charges. This option helps reduce travel costs while ensuring comfortable transportation."
},
{
name: "Mumbai to Bhimashankar Innova Cab",
description: "Innova cab from Mumbai to Bhimashankar is perfect for families and groups needing spacious seating and luggage capacity. The premium MPV offers comfortable travel for long-distance temple journeys."
}
],

tableData: [
["Mumbai to Bhimashankar Cab","Mumbai to Bhimashankar Taxi"],
["Mumbai to Bhimashankar Cab Service","Mumbai to Bhimashankar Taxi Service"],
["Cab from Mumbai to Bhimashankar","Taxi from Mumbai to Bhimashankar"],
["Mumbai to Bhimashankar Cab Booking","Mumbai to Bhimashankar Taxi Booking Online"],
["Mumbai to Bhimashankar Cab Price","Mumbai to Bhimashankar Taxi Fare"],
["Mumbai to Bhimashankar Temple Cab","Mumbai to Bhimashankar Jyotirlinga Cab"],
["Mumbai to Bhimashankar One Way Cab","Mumbai to Bhimashankar Innova Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Ghat Road Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through the ghat roads and forest routes leading to Bhimashankar. Their knowledge of winding hill roads, weather conditions, and safe driving techniques ensures a smooth and secure pilgrimage journey from Mumbai to Bhimashankar."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a transparent pricing policy for Mumbai to Bhimashankar cab services. We clearly inform customers about per-kilometer charges, tolls, and trip packages before confirmation so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Pilgrimage trips to Bhimashankar often start early morning or late at night. Omshree Cabs operates 24/7 to provide convenient cab bookings from Mumbai to Bhimashankar whenever you plan your journey."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet consists of well-maintained and fully air-conditioned vehicles suitable for long-distance travel. Each car is regularly cleaned and sanitized to ensure a comfortable and hygienic ride for passengers."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "Omshree Cabs offers flexible travel packages including one-way trips, round trips, and same-day Bhimashankar darshan packages. We customize your travel plan according to your schedule and preferences."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from comfortable sedan cars, spacious SUVs like Ertiga and Innova, or premium vehicles depending on your group size and travel comfort. We ensure the right vehicle for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from your home, hotel, office, or airport anywhere in Mumbai. Our driver arrives on time so your Mumbai to Bhimashankar trip starts smoothly without travel stress."
  },
  {
    WhyChooseheading: "Reliable Pilgrimage Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for religious trips and temple visits. Our punctual service, safe driving, and customer-friendly support make your Bhimashankar pilgrimage comfortable and hassle-free."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Bhimashankar by cab?", answer: "The distance from Mumbai to Bhimashankar is approximately 220 km and the journey usually takes around 5–6 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Bhimashankar cab services?", answer: "Yes, Omshree Cabs offers both one-way and round-trip cab services from Mumbai to Bhimashankar." },
  { question: "Is same-day Bhimashankar darshan possible from Mumbai?", answer: "Yes, many travelers book same-day return cab packages for Bhimashankar temple darshan from Mumbai." },
  { question: "Which vehicles are available for Bhimashankar travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort requirements." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we offer direct pickup from Mumbai Airport for Bhimashankar cab bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Is Bhimashankar part of the 12 Jyotirlinga temples?", answer: "Yes, Bhimashankar is one of the twelve sacred Jyotirlinga temples of Lord Shiva and a popular pilgrimage destination." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, Shravan month, and festival seasons." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Sharma",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Bhimashankar temple trip. The driver handled the ghat roads very well and the car was clean and comfortable. Excellent pilgrimage travel service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kulkarni",
    feedback:
      "Our Bhimashankar darshan trip from Mumbai with Omshree Cabs was very smooth. On-time pickup, safe driving, and transparent pricing made the journey stress-free.",
    rating: 5
  }
];


























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhimashankar Cab",
  "description": "Book Mumbai to Bhimashankar Cab with Omshree Cab for comfortable temple and outstation travel. Reliable taxi service from Mumbai to Bhimashankar Jyotirlinga with options like Innova and other cabs for one-way or round trips. Affordable fares and easy online cab booking for Bhimashankar temple visits.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai to Bhimashankar Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Bhimashankar Cab with Omshree Cab for comfortable temple travel. Taxi service from Mumbai to Bhimashankar Jyotirlinga with Innova and other cabs for one-way or round trips. Affordable fares and easy online cab booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhimashankarcab;